import { render } from "./TournamentCategoryList.vue?vue&type=template&id=3d4c16ee&scoped=true"
import script from "./TournamentCategoryList.vue?vue&type=script&lang=js"
export * from "./TournamentCategoryList.vue?vue&type=script&lang=js"

import "./TournamentCategoryList.vue?vue&type=style&index=0&id=3d4c16ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4c16ee"]])

export default __exports__